export const normalizePayorId = (value) => value.trim().toUpperCase();

export const validatePayor = (field, value) => {
  if (field === 'id') {
    const id = normalizePayorId(value);
    if (!id) return { id: 'Payor ID is required' };
    if (/\s/.test(id)) return { id: 'Payor ID must not contain spaces' };
    if (id.length > 128) return { id: 'Payor ID must be 128 characters or fewer' };
    return { id: '' };
  }
  if (field === 'payorName') {
    return { payorName: value.trim() ? '' : 'Payor name is required' };
  }
  return {};
};

export const catchErrors = (data) => {
  const errors = {
    ...validatePayor('id', data.id),
    ...validatePayor('payorName', data.payorName),
  };
  return { errors, hasErrors: Object.values(errors).some((e) => e) };
};

export const getIsButtonEnabled = (data, errors) =>
  Boolean(data.id.trim() && data.payorName.trim()) && !Object.values(errors).some((e) => e);
